<template>
  <!--  添加和编辑工友  -->
  <el-dialog :append-to-body="true"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :title="edittype?'新增工友':'编辑工友'"
             :visible.sync="showEdit"
             center
             width="600px">
    <StepsUI v-if="showEdit"
             :list="edittype?['新增工友','新增工资']:['编辑工友','编辑工资']"
             :steps="steps"></StepsUI>
    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="120px">
      <div v-if="steps==1">
        <el-form-item label="工友姓名"
                      prop="name">
          <el-input v-model="form.name"
                    placeholder="请输入工友姓名"></el-input>
        </el-form-item>
        <el-form-item label="工友电话"
                      prop="phone">
          <el-input v-model="form.phone"
                    placeholder="请输入工友电话"></el-input>
        </el-form-item>
      </div>
      <div v-else-if="steps==2"
           class="steps2">
        <el-form-item label="上班标准："
                      prop="workStandard">
          <el-input v-model="form.workStandard"
                    @focus="showTime1=true"></el-input>
          <span>小时算1个工</span>
        </el-form-item>
        <el-form-item label="每个工多少钱："
                      prop="workStandardSalary">
          <el-input v-model="form.workStandardSalary" @input="Mixin_commonLimitInput('form.workStandardSalary',6,0,false)"></el-input>
          <span>元/个工</span>
        </el-form-item>
        <div style="display: table-row;">
          <div style="display: table-cell;width: 120px;text-align: right;box-sizing: border-box;padding-right: 12px;">
            加班标准：
          </div>
          <div style="display: table-cell">
            <el-radio-group v-model="form.workOvertimeType"
                            @change="v=>{v==1&&injectWorkOvertimeSalary()}">
              <el-radio label="1">按工天算</el-radio>
              <el-radio label="2">按小时算</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div style="display: table;width: 100%;margin-bottom: 20px">
          <div style="display: table-cell;width: 120px;text-align: right;box-sizing: border-box;padding-right: 12px;"></div>
          <div style="display: table-cell;width: calc(100% - 120px)">
            <div style="background: #F5F7FA;padding: 10px;margin-top: 20px">
              <div>
                <el-form-item v-if="form.workOvertimeType==1"
                              label="加班标准："
                              label-width="82px"
                              prop="workOvertimeStandard">
                  <el-input v-model="form.workOvertimeStandard"
                            @focus="showTime2=true"></el-input>
                  <span>加班{{ form.workOvertimeStandard }}小时算一个工</span>
                </el-form-item>
                <div v-if="form.workOvertimeType==1">加班每小时多少钱：{{ injectWorkOvertimeSalary() }}元/小时</div>
                <el-form-item label="加班每小时多少钱："
                              label-width="140px"
                              v-if="form.workOvertimeType==2"
                              prop="workOvertimeSalary">
                  <el-input  v-model="form.workOvertimeSalary" @input="Mixin_commonLimitInput('form.workOvertimeSalary',6,2,true)"></el-input>
                  <!-- <el-input v-inputLimit="/^((\d{0,6})|(\d{0,6}\.(\d{1,2})?))$/"
                            v-model="form.workOvertimeSalary"></el-input> -->
                  <span>元/小时</span>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <WorkTimeSelect :value.sync="form.workStandard"
                        :visiable.sync="showTime1"></WorkTimeSelect>
        <WorkTimeSelect :value.sync="form.workOvertimeStandard"
                        :visiable.sync="showTime2"></WorkTimeSelect>
      </div>

    </el-form>
    <div slot="footer"
         style="text-align: center;">
      <el-button v-if="steps==1"
                 type="primary"
                 @click="setpsdown">下一步
      </el-button>
      <el-button v-if="steps==2"
                 @click="steps=1">上一步
      </el-button>
      <el-button v-if="steps==2"
                 @click="resetFields()">重置工资
      </el-button>
      <el-button v-if="steps==2"
                 type="primary"
                 @click="edit">完成{{ edittype ? '新增' : '编辑' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {api} from '@/api/apiRecord.js'
import {wokerForm} from '@/mixins/validate/work.js'
export default {
  name: "workerEdit",
  mixins: [wokerForm],
  components: {
    StepsUI: () => import("@/components/StepsUI/StepsUI"),
    WorkTimeSelect: () => import("../statistics/statisticsBtn/components/workTimeSelect"), // 选择工作时长弹窗
  },
  data() {
    return {
      showEdit: false,
      showTime1: false,//上班时间
      showTime2: false,//加班时间
      loading: false,
      form: {
        name: '',
        phone: '',
        workOvertimeSalary: '',
        workOvertimeStandard: '',
        workOvertimeType: '1',
        workStandard: '',
        workStandardSalary: '',
        salaryStandardNo: '',
        settleWorkerNo: ''
      },
      edittype: false,//是否是编辑状态
      rules: {
        name: [{required: true, message: '姓名不能为空'},{ min: 1, max: 10, message: '姓名不能超过 10 个字符', trigger: 'change' }],
        phone: [{pattern: /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号码格式'}],
        workStandardSalary:[{pattern: /^(\d{0,6})$/, message: '支持最多6位数字'}],
        workOvertimeSalary:[{pattern: /^(\d{0,6})+(.[0-9]{1,2})?$/, message: '请输入正确数字，支持两位小数'}],
      },
      steps: 1,
      type: this.$route.query.type ? this.$route.query.type : 1,//当前页面进入模式1.个人记工2.班组记工
    }
  },
  methods: {
    open(row = {}) {
      this.loading = false
      this.steps = 1
      this.showEdit = true
      let form = {...row}
      let salaryStandardVo = {...row.salaryStandardVo}
      delete salaryStandardVo.no
      delete form.salaryStandardVo
      form = {...form, ...salaryStandardVo}
      !form.workOvertimeType && (form.workOvertimeType = '1')
      for (let i in this.form) {
        this.form[i] = form[i] ? form[i] : ''
      }
      this.form = {...form}
      this.edittype = !form.name
      this.$nextTick(_=>{
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    setpsdown() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.steps = 2;
      })
    },
    injectWorkOvertimeSalary() {
      let {workStandardSalary, workOvertimeStandard} = this.form;
      if(!workOvertimeStandard){
        return 0
      }
      let str=(+workStandardSalary) / (+workOvertimeStandard)
      return isNaN(str)?0:str.toFixed(2);
    },
    async edit() {
      if (this.loading) return;
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        let {workStandard,workStandardSalary,workOvertimeType,workOvertimeStandard,workOvertimeSalary,}=this.form
        if((workOvertimeType==2&&!workOvertimeSalary)||(workOvertimeType==1&&!workOvertimeStandard)||!workStandard||!workStandardSalary){
          this.$message.tips('当前工资标准未设置完全，是否暂不设置工资标准？',async (v)=>{
            if(v){
              this.resetFields()
              await this.save()
            }
          })
        }else{
          await this.save()
        }
      })
    },
    async save(){
      this.form.type = this.type;//1:个人记工,2:个人记账,3:班组记工,4:班组记账
      this.loading = true;
      let res = await api.settleWorkerAdd(this.form);
      if (res.data.code == 200) {
        this.showEdit = false;
        this.$message.success(res.data.msg);
        this.$emit('editend', res.data.data)
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },
    //仅清空工资相关字段
    resetFields(){
      ['workStandard','workStandardSalary','workOvertimeStandard','workOvertimeSalary'].forEach(v=>{
        this.form[v]=''
      })
    }

  }
}
</script>

<style lang="scss"
       scoped>
/deep/ .el-dialog__body {
  padding: 30px 20px 0;
}

/deep/ .el-dialog__footer {
  padding-top: 20px;
  padding-bottom: 40px;
}

/deep/ .el-button + .el-button {
  margin-left: 20px;
}

.steps2{
  /deep/ .el-form-item__label{
    height: 30px;
    line-height: 30px;
  }
  /deep/ .el-form-item__content{
    height: 30px;
    line-height: 30px;
  }
  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
}


/deep/ .el-form-item {
  margin-bottom: 20px;
}

/deep/ .el-form-item__error {
  padding: 0;
}

/deep/ .steps2 {
  .el-input {
    width: 120px;
    margin-right: 10px
  }
}
.el-button--primary {
    color: #fff;
    border-color: #B79255;
    background: #B79255;
    &:hover,&:focus{
      color: #fff;
      border-color: #B79255;
      background: #B79255;

    }
  }
</style>
